/**
 * Image slider
 */
var component_image_slider = function(args) {

  // setup args
  var container = args.container.querySelector('.swiper-container');

  if (container.querySelectorAll('.swiper-slide').length > 1) {
    var swiper = new Swiper (container, {
      // optional parameters
      direction: 'horizontal',
      loop: true,
      autoHeight: true,
      grabCursor: true,
      autoplay: {
        delay: 10000,
      },

      // Enable lazy loading
      lazy: true,

      // pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  } else {
    container.classList.add('disabled');
  }


  // make the call chainable
  return this;

};
